<template>
  <div class="question-content">
    <v-container fluid grid-list-md>
      <wes-q-text v-bind:metadata="question"></wes-q-text>

      <div id="q16Errs" style="width:100%;height:15px;"></div>
      <err-panel v-if="bDisplayErrors===true" v-on:closepanel="onClosePanel" v-bind:errors="errorList" v-on:closeerrorpanel="onErrorPanelCleared"></err-panel>

      <v-layout row wrap>
        <v-flex xs12>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark :curentAnswer="currentAnswer" @click="onFillZerosClicked(currentAnswer)">Fill With Zeros</v-btn>
          </div>
        </v-flex>
        <v-flex xs12><hr /><br /></v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs7>
          <p class="column-header">{{ colHeaders[0].colLabel }}</p>
        </v-flex>
        <v-flex v-for="colHeaders in filteredColHeaders" :key="colHeaders.colHeader" xs1>
          <p class="column-header">{{ colHeaders.colHeader }}<br />{{ colHeaders.colLabel }}</p>
        </v-flex>
      </v-layout>

      <v-layout v-for="(category, categoryIndex) in this.labels" :key="category.categoryHeading" row>
        <!-- <v-layout v-if="category.subs == ''" row> -->
          <v-flex xs7>
            <p class="row-header">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
          </v-flex>

          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][0]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 0, $event)"></v-text-field>
          </v-flex>
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(0)" @change="q16Updated(grandRowsTotals(0))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][1]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 1, $event)"></v-text-field>
          </v-flex>
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(1)" @change="q16Updated(grandRowsTotals(1))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][2]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 2, $event)"></v-text-field>
          </v-flex>
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(2)" @change="q16Updated(grandRowsTotals(2))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][3]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 3, $event)"></v-text-field>
          </v-flex>
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(3)" @change="q16Updated(grandRowsTotals(3))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="totalCols(categoryIndex, 0, 4)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandTotalComputedRows(4)" @change="q16Updated(grandRowsTotals(4))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

        <!-- </v-layout> -->

      </v-layout>

      <br /><br />

      <v-layout row wrap>
        <v-flex xs7>
            <p class="row-label">Cross check: totals in row j above should match the FY 2021 amounts from question 5, rows a–d displayed here.</p>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="columnTotalsCrossCheck(0)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="columnTotalsCrossCheck(1)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="columnTotalsCrossCheck(2)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="columnTotalsCrossCheck(3)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="total6(columnTotalsCrossCheck(0), columnTotalsCrossCheck(1), columnTotalsCrossCheck(2), columnTotalsCrossCheck(3), columnTotalsCrossCheck(4), columnTotalsCrossCheck(5), columnTotalsCrossCheck(6))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
      </v-layout>

      <answer-explain :label="question.explanation.label" v-bind:explaination="x"></answer-explain>

      <v-layout row wrap>
        <v-flex xs2><v-icon class="help-ico" v-on:click="onHandleHelpClicked(true)">fa fa-question-circle</v-icon></v-flex>
        <v-flex xs10>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark v-on:click="onSaveClicked">Save</v-btn>
          </div>
        </v-flex>
      </v-layout>

    </v-container>
    <help-panel v-if="bDisplayHelp===true" v-on:closepanel="onClosePanel" v-bind:question="question"></help-panel>
  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { utilityService } from '../../services/utilityService';
import { errorService } from '../../services/errorService';
export default {
  name: 'Question6',
  props: {
    question: Object,
    qId: String
  },
  data: () => ({
    isHelpDisplayed: false,
    isErrorsOverlayDisplayed: false,
    x: '',
    colHeaders: [
      { colHeader: '', colLabel: 'FFRDC' },
      { colHeader: '(a)', colLabel: 'Basic research' },
      { colHeader: '(b)', colLabel: 'Applied research' },
      { colHeader: '(c)', colLabel: 'Experimental development' },
      { colHeader: '(d)', colLabel: 'R&D plant' },
      { colHeader: '(e)', colLabel: 'Total R&D conduct and plant' }
    ],

    labels: [
      { categoryHeading: '1',
categoryLabel: 'Aerospace Federally Funded Research and Development Center ',
        subs: ['']
      },
      { categoryHeading: '2',
categoryLabel: 'Ames Laboratory ',
        subs: ['']
      },
      { categoryHeading: '3',
categoryLabel: 'Argonne National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '4',
categoryLabel: 'Arroyo Center ',
        subs: ['']
      },
      { categoryHeading: '5',
categoryLabel: 'Brookhaven National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '6',
categoryLabel: 'Center for Advanced Aviation System Development',
        subs: ['']
      },
      { categoryHeading: '7',
categoryLabel: 'Center for Communications and Computing ',
        subs: ['']
      },
      { categoryHeading: '8',
categoryLabel: 'Center for Enterprise Modernization ',
        subs: ['']
      },
      { categoryHeading: '9',
categoryLabel: 'Center for Naval Analyses ',
        subs: ['']
      },
      { categoryHeading: '10',
categoryLabel: 'Center for Nuclear Waste Regulatory Analyses ',
        subs: ['']
      },
      { categoryHeading: '11',
categoryLabel: 'CMS Alliance to Modernize Healthcare ',
        subs: ['']
      },
      { categoryHeading: '12',
categoryLabel: 'Fermi National Accelerator Laboratory ',
        subs: ['']
      },
      { categoryHeading: '13',
categoryLabel: 'Frederick National Laboratory for Cancer Research ',
        subs: ['']
      },
      { categoryHeading: '14',
categoryLabel: 'Homeland Security Operational Analysis Center ',
        subs: ['']
      },
      { categoryHeading: '15',
categoryLabel: 'Homeland Security Systems Engineering and Development Institute ',
        subs: ['']
      },
      { categoryHeading: '16',
categoryLabel: 'Idaho National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '17',
categoryLabel: 'Jet Propulsion Laboratory ',
        subs: ['']
      },
      { categoryHeading: '18',
categoryLabel: 'Judiciary Engineering and Modernization Center ',
        subs: ['']
      },
      { categoryHeading: '19',
categoryLabel: 'Lawrence Berkeley National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '20',
categoryLabel: 'Lawrence Livermore National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '21',
categoryLabel: 'Lincoln Laboratory ',
        subs: ['']
      },
      { categoryHeading: '22',
categoryLabel: 'Los Alamos National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '23',
categoryLabel: 'National Biodefense Analysis and Countermeasures Center ',
        subs: ['']
      },
      { categoryHeading: '24',
categoryLabel: 'National Center for Atmospheric Research ',
        subs: ['']
      },
      { categoryHeading: '25',
categoryLabel: 'National Cybersecurity Center of Excellence ',
        subs: ['']
      },
      { categoryHeading: '26',
categoryLabel: 'National Defense Research Institute ',
        subs: ['']
      },
      { categoryHeading: '27',
categoryLabel: 'National Optical Astronomy Observatory ',
        subs: ['']
      },
      { categoryHeading: '28',
categoryLabel: 'National Radio Astronomy Observatory ',
        subs: ['']
      },
      { categoryHeading: '29',
categoryLabel: 'National Renewable Energy Laboratory ',
        subs: ['']
      },
      { categoryHeading: '30',
categoryLabel: 'National Security Engineering Center -- Bedford, MA Laboratory ',
        subs: ['']
      },
      { categoryHeading: '31',
categoryLabel: 'National Security Engineering Center -- McLean, VA Laboratory ',
        subs: ['']
      },
      { categoryHeading: '32',
categoryLabel: 'National Solar Observatory ',
        subs: ['']
      },
      { categoryHeading: '323',
categoryLabel: 'Oak Ridge National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '34',
categoryLabel: 'Pacific Northwest National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '35',
categoryLabel: 'Princeton Plasma Physics Laboratory ',
        subs: ['']
      },
      { categoryHeading: '36',
categoryLabel: 'Project Air Force ',
        subs: ['']
      },
      { categoryHeading: '37',
categoryLabel: 'Sandia National Laboratories ',
        subs: ['']
      },
      { categoryHeading: '38',
categoryLabel: 'Savannah River National Laboratory ',
        subs: ['']
      },
      { categoryHeading: '39',
categoryLabel: 'Science and Technology Policy Institute ',
        subs: ['']
      },
      { categoryHeading: '40',
categoryLabel: 'SLAC National Accelerator Laboratory ',
        subs: ['']
      },
      { categoryHeading: '41',
categoryLabel: 'Software Engineering Institute ',
        subs: ['']
      },
      { categoryHeading: '42',
categoryLabel: 'Systems and Analyses Center ',
        subs: ['']
      },
      { categoryHeading: '43',
categoryLabel: 'Thomas Jefferson National Accelerator Facility ',
        subs: ['']
      },
      { categoryHeading: '44',
categoryLabel: 'Total ',
        subs: ['']
      }
    ],
    currentAnswer: [
      { answerCategory: '1', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '2', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '3', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '4', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '5', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '6', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '7', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '8', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '9', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '10', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '11', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '12', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '13', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '14', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '15', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '16', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '17', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '18', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '19', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '20', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '21', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '22', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '23', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '24', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '25', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '26', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '27', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '28', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '29', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '30', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '31', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '32', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '33', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '34', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '35', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '36', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '37', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '38', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '39', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '40', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '41', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '42', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '43', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '44', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: '55', answerFields: [['', '', '', '', '']] }
    ],
    crossCheckAnswer: [
      { answerCategory: 'a', answerFields: [['1', '2', '3', '4', '']] },
      { answerCategory: 'b', answerFields: [['5', '6', '7', '8', '']] },
      { answerCategory: 'c', answerFields: [['9', '10', '11', '12', '']] },
      { answerCategory: 'd', answerFields: [['13', '14', '15', '16', '']] },
      { answerCategory: 'e', answerFields: [['17', '18', '19', '20', '']] },
      { answerCategory: 'f', answerFields: [['21', '22', '23', '24', '']] },
      { answerCategory: 'g', answerFields: [['25', '26', '27', '28', '']] },
      { answerCategory: 'h', answerFields: [['', '', '', '', '']] },
      { answerCategory: 'i', answerFields: [['', '', '', '', '']] }
    ]
  }),
  methods: {
    q16Updated: function (val) {
      // this.$emit("q16Totals", val);
    },
    onFillZerosClicked: function () {
      const categories = this.currentAnswer.length;
      for (var i = 0; i < categories; i++) {
        const rowsInCategory = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < rowsInCategory; j++) {
          const columns = this.currentAnswer[i].answerFields[j].length;
          for (var k = 0; k < columns; k++) {
            if (this.currentAnswer[i].answerFields[j][k] === '') {
              this.currentAnswer[i].answerFields[j][k] = '0';
              this.currentAnswer.push();
              // console.log('categories=' + categories + ' rowsInCategory=' + rowsInCategory + ' columns=' + columns)
            }
          }
        }
      }
    },
    updateAnswerValue: function (id, idx, item, val) {
      this.currentAnswer[id].answerFields[idx][item] = val;
    },
    onValueChanged: function (event) {
      console.log('On Value Changed.');
    },
    onSaveClicked: function () {
      console.log('Called save with: ' + this.currentAnswer);
      answerService.saveSurveyQuestionAnswer(0, this.$props.question.id, this.currentAnswer);
      this.errorList = errorService.runValidationForQuestion(this.$props.question.id);
      this.isErrorsOverlayDisplayed = true;
      utilityService.scrollElemIntoView('q16Errs');
    },
    onClosePanel: function () {
      this.isErrorsOverlayDisplayed = false;
      this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    },
    totalCols: function (category, subcategory, colTotal) {
      var total = 0;
      // console.log("one=" + one + ", two=" + two + ", three=" + three);
      var totalCols = colTotal;
      for (var i = 0; i < totalCols; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[subcategory][i])
      }
      return total;
    },
    totalRows: function (category, colIndex) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][colIndex])
      }
      return total;
    },
    totalComputedRows: function (category) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        var totalCols = this.currentAnswer[category].answerFields[i].length;
        for (var j = 0; j < totalCols; j++) {
          console.log("i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
          total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]);
        }
      }
      return total;
    },
    grandTotalComputedRows: function () {
      var total = 0;
      var totalCategories = this.currentAnswer.length;
      for (var h = 0; h < totalCategories; h++) {
        var totalRows = this.currentAnswer[h].answerFields.length;
        for (var i = 0; i < totalRows; i++) {
          var totalCols = this.currentAnswer[h].answerFields[i].length;
          for (var j = 0; j < totalCols; j++) {
            // console.log("h=" + h + ", i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
            total += utilityService.convertStringToNum(this.currentAnswer[h].answerFields[i][j]);
          }
        }
      }
      return total;
    },
    grandRowsTotals: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.currentAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.currentAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    columnTotalsCrossCheck: function (row) {
      var total = 0;
      var totalCategories = this.crossCheckAnswer.length;
      for (var i = 0; i < 3; i++) {
          total += utilityService.convertStringToNum(this.crossCheckAnswer[row].answerFields[0][i])
      }
      return total;
    },
    total6: function (num1, num2, num3, num4, num5, num6) {
      return num1 + num2 + num3 + num4 + num5 + num6;
    },
    getValues: function (val1, val2) {
      console.log("Val1=" + val1 + " Val2=" + val2);
    }
  },
  computed: {
		bDisplayHelp: function () {
			return this.isHelpDisplayed;
		},
		bDisplayErrors: function () {
			return this.isErrorsOverlayDisplayed;
    },
    filteredColHeaders () {
      return this.colHeaders.slice(1, 8);
    }
  }
};
</script>

<style scoped>
.v-text-field {
  height: 60px;
  margin: 0px;
}
.container {
  max-width: 90%;
  padding: 5px;
}
.column-header {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
.row-header {
  line-height: 60px;
  margin: 0px;
  font-weight: bold;
  font-size: 14px;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  /* position: relative; */
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  line-height: 20px;
  margin: 0px 0px 0px 40px;
  font-weight: normal;
  font-size: 16px;
}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: chartreuse;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  line-height: 44px;
  color: #0000ffa3;
}
.bordered {
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  border-width: 1px 1px 1px 2px;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
.left {
  text-align: left;
}
</style>
